export class ErrorLogger {
  private static logs: Array<{ timestamp: string; type: string; message: string; data?: any }> = []

  static log(type: string, message: string, data?: any) {
    const timestamp = new Date().toISOString()
    const logEntry = { timestamp, type, message, data }
    this.logs.push(logEntry)

    console.log(`[v0 ${type}] ${timestamp} - ${message}`, data || "")

    // حفظ في localStorage للوصول إليها لاحقاً
    if (typeof window !== "undefined") {
      try {
        localStorage.setItem("v0-error-logs", JSON.stringify(this.logs))
      } catch (e) {
        console.error("[v0] Failed to save logs to localStorage", e)
      }
    }
  }

  static logError(message: string, error: Error | any) {
    this.log("ERROR", message, {
      message: error?.message,
      stack: error?.stack,
      name: error?.name,
    })
  }

  static getLogs() {
    return this.logs
  }

  static clearLogs() {
    this.logs = []
    if (typeof window !== "undefined") {
      localStorage.removeItem("v0-error-logs")
    }
  }

  static downloadLogs() {
    const logsText = JSON.stringify(this.logs, null, 2)
    const blob = new Blob([logsText], { type: "application/json" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `error-logs-${Date.now()}.json`
    a.click()
    URL.revokeObjectURL(url)
  }
}
